import { View } from "react-native";
import { Icon, Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { TransactionDetails } from "../../../types";
import CardText from "../../CardText";

type Props = {
  fulfillment?: TransactionDetails["consumer"]["fulfillment"];
};

export default function ConsumerFulfillmentInfo({ fulfillment }: Props) {
  const tailwind = useTailwind();
  const { colors } = useTheme();

  if (!fulfillment) {
    return null;
  }

  const {
    details,
    detailsType,
    instructions,
    trackingNumber,
    tracking_instructions,
  } = fulfillment;

  const title = detailsType || "Datos de entrega";
  const text = details || "Tu cliente no ha seleccionado opción de entrega.";

  return (
    <View>
      {trackingNumber && tracking_instructions && (
        <View style={tailwind("flex-row -mt-4 mb-4")}>
          <View style={tailwind("mr-1")}>
            <Icon
              source="information-outline"
              color={colors.secondary}
              size={20}
            />
          </View>
          <View style={tailwind("flex-col justify-center")}>
            <Text
              variant="labelMedium"
              style={[{ color: colors.onSurfaceVariant }]}
            >
              Por favor, escribe el{" "}
              <Text
                variant="labelMedium"
                style={[
                  { color: colors.onSurfaceVariant },
                  tailwind("font-bold"),
                ]}
              >
                número de rastreo
              </Text>{" "}
              en el paquete.
            </Text>
          </View>
        </View>
      )}
      {trackingNumber && (
        <>
          <View style={tailwind("mb-4")}>
            <CardText.Subtitle
              text="Número de rastreo"
              style={tailwind("mb-1")}
            />
            <CardText.Body text={trackingNumber} />
          </View>
        </>
      )}
      <CardText.Subtitle text={title} style={tailwind("mb-1")} />
      <CardText.Body text={text} error={!details} />
      {instructions && (
        <View style={tailwind("mt-4")}>
          <CardText.Subtitle
            text="Instrucciones adicionales"
            style={tailwind("mb-1")}
          />
          <CardText.Body text={instructions} />
        </View>
      )}
    </View>
  );
}
